import { storeStructure } from '../store/reducers';
import tableComposeExperience from './tableComposeExperience';

export default {
  title: 'Medias',
  attributeName: storeStructure.ComposeExperience,
  getURL: 'composeExperience',
  createURL: 'composeExperience',
  updateURL: 'composeExperience',
  removeURL: 'composeExperience',
  sessionParams: [],
  noArea: true,
  tableConfig: tableComposeExperience,
  autoUpdate: true,
  // websocketNavigation:'users_navigation',

};
